var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"7","viewBox":"0 0 12 7","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.98.167A.26.26 0 0 0 11.74 0H.26C.157 0 .062.066.02.168a.285.285 0 0 0 .054.297l5.74 6.202A.255.255 0 0 0 6 6.75c.07 0 .138-.03.187-.083l5.74-6.202a.285.285 0 0 0 .052-.298z","fill":"#05163D","fill-rule":"nonzero"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }